var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.867 10.149c0-1.864.845-3.583 1.984-5.291C6.497.891 4.182-1.093 6.497.891c3.141 3.141 1.064 7.275 2.976 7.275 1.653 0 1.486-3.145 1.486-3.145.001-.364.223-.465.489-.212 0 0 2.654 2.108 2.654 5.34 0 2.602-1.383 4.95-3.637 5.952l-.63-.719c-.931-1.064-2.44-1.063-3.371 0l-.629.72c-2.254-1.001-3.968-3.206-3.968-5.952zM8.889.839c.51-.088 1.666.441 2.261 1.36.832 1.328-1.144 1.923-1.447.463S8.379.927 8.889.839z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotOffer);
export default __webpack_public_path__ + "static/media/HotOffer.64b89fbff55b5ff7550549ce8f5cce61.svg";
export { ForwardRef as ReactComponent };